/**
 * @file apps/web/src/pages/NotFoundPage.tsx
 * @description 404 not found page.
 */

import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center h-full py-24">
      <p className="font-mono text-muted text-sm mb-2">404</p>
      <h1 className="font-display text-4xl font-bold text-ink mb-4">
        Page not found
      </h1>
      <Link
        to="/dashboard"
        className="text-blue text-sm font-medium hover:underline"
      >
        Go to Dashboard
      </Link>
    </div>
  );
}
